module.exports = __webpack_public_path__ + "static/1-e1c70ccfe21d85ab7b0f2ef52f30f24e.jpg";